import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Heading, Text } from '@leroy-merlin-br/backyard-react-ui'

const sectionStyles = ({ theme }) => css`
  label: section;

  padding: ${theme.spacings.tera} 0 ${theme.spacings.exa} 0;

  background: ${theme.colors.background};

  ${theme.media.giga} {
    padding-bottom: 120px;
  }
`

const cardsContainerStyles = ({ theme }) => css`
  label: section__cards-container;

  display: flex;
  justify-content: space-between;

  margin: ${theme.spacings.exa} 0;
`

const cardStyles = ({ theme }) => css`
  label: section__card;

  position: relative;

  padding: ${theme.spacings.mega};
  margin-bottom: ${theme.spacings.byte};
  box-sizing: border-box;

  width: 160px;
  min-height: 265px;

  text-align: center;
  border-radius: ${theme.borderRadius.mega};
  background: ${theme.colors.white};
  color: ${theme.colors.n400};
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.1);

  ${theme.media.tera} {
    margin: 0;
  }

  svg {
    display: block;

    fill: ${theme.colors.f600};

    margin: 0 auto;
    margin-bottom: ${theme.spacings.giga};

    max-width: ${theme.spacings.zetta};
  }
`

const sectionTitleStyles = ({ theme }) => css`
  color: ${theme.colors.n800};
  font-weight: ${theme.font.weight.regular};
`

const cardTitleStyles = ({ theme }) => css`
  color: ${theme.colors.n800};
`

export const Section = styled('section')(sectionStyles)
export const CardsContainer = styled('div')(cardsContainerStyles)
export const Card = styled('div')(cardStyles)

export const SectionTitle = styled(Heading)(sectionTitleStyles)
export const CardTitle = styled(Text)(cardTitleStyles)
